import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {Observable} from 'rxjs';
import {AlertManagerState, InputTypeEnum, Pageable, Template} from 'src/app/models';

@Injectable({
    providedIn: 'root'
})
export class TemplateService {
    constructor(public http: HttpClient) {
    }

    getTemplates(): Observable<Template[]> {
        return this.http.get<Template[]>('api/v1/templates');
    }

    getAllTemplatesPage(page): Observable<Pageable<Template>> {
        return this.http.get<Pageable<Template>>(`api/v1/templates?&size=${page.limit}&page=${page.offset}&sort=${page.orderBy},${page.orderDir}`);
    }

    getTemplatesWithIdentifierPage(identifier: string, page): Observable<Pageable<Template>> {
        identifier = encodeURIComponent(identifier);
        return this.http.get<Pageable<Template>>(`api/v1/templates?identifier=${identifier}&size=${page.limit}&page=${page.offset}&sort=${page.orderBy},${page.orderDir}`);
    }

    getTemplateNamesPageSize(identifier: string, page: number): Observable<Pageable<Template>> {
        identifier = encodeURIComponent(identifier);
        return this.http.get<Pageable<Template>>(`api/v1/templates?identifier=${identifier}&size=${page}`);
    }

    getTemplate(identifier?: string, isAlertManager?: AlertManagerState): any {
        return this.http.get(`api/v1/templates?identifier=${identifier ? encodeURIComponent(identifier) : identifier}&isAlertManager=${isAlertManager || AlertManagerState.ALL}`);
    }

    getTemplateById(id: number) {
        return this.http.get<Template>(`api/v1/templates/${id}`);
    }

    createTemplate(template: any): any {
        return this.http.post('/api/v1/templates', template);
    }

    deleteTemplate(id: number): any {
        return this.http.delete(`/api/v1/templates/${id}`);
    }

    updateTemplate(template: any): any {
        return this.http.put(`/api/v1/templates`, template);
    }

    getInputType(name: string): InputTypeEnum {
        switch (name.toLowerCase()) {
            case 'clients':
                return InputTypeEnum.CLIENTS;
            case 'applications':
                return InputTypeEnum.APPLICATIONS;
            case 'individual':
            case 'sentby':
                return InputTypeEnum.SENTBY;
            case 'date':
                return InputTypeEnum.DATE;
            case 'confirm':
                return InputTypeEnum.CONFIRM;
            default:
                return InputTypeEnum.TEXTAREA;
        }
    }
}
